import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`;

export const ContainerMobile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;

  > button {
    max-width: 100%;
  }
`;

